import React from 'react'
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppUsersAutocomplete({ ...props }) {

	return <AutocompleteAjaxSeeker
		label="Company Users"
		placeholder="All users"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/company-users`}
		{...props}
	/>
}